var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.48 7.97c2.856 0 5.17-1.337 5.17-2.985C21.65 3.336 19.336 2 16.48 2c-2.855 0-5.17 1.336-5.17 2.985 0 1.648 2.315 2.984 5.17 2.984zm12.395 9.437c1.438.825 1.446 3.483.018 5.937-1.427 2.454-3.75 3.776-5.188 2.952-1.438-.824-1.447-3.482-.02-5.937 1.429-2.455 3.752-3.777 5.19-2.953zM21.65 27.474c0 1.648-2.314 2.984-5.17 2.984-2.855 0-5.17-1.336-5.17-2.984 0-1.649 2.315-2.985 5.17-2.985 2.856 0 5.17 1.335 5.17 2.984zM9.255 6.164c1.44.824 1.448 3.482.02 5.937-1.427 2.455-3.75 3.776-5.19 2.952-1.439-.825-1.448-3.483-.02-5.938 1.427-2.454 3.751-3.776 5.19-2.95zm0 20.131c1.44-.825 1.45-3.483.022-5.937-1.428-2.455-3.752-3.776-5.19-2.951-1.44.825-1.45 3.483-.022 5.937 1.428 2.455 3.752 3.776 5.19 2.951zm19.64-17.18c1.427 2.455 1.42 5.113-.02 5.937-1.437.825-3.76-.497-5.188-2.952-1.427-2.454-1.419-5.112.02-5.936 1.437-.824 3.76.497 5.188 2.952z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotdown);
export default __webpack_public_path__ + "static/media/DOTDOWN.631571c1f4e45875994be1c3ad49f3ab.svg";
export { ForwardRef as ReactComponent };